import { __rest } from "tslib";
import React, { createContext, useContext } from 'react';
export var VideoConfigContext = createContext({});
export var VideoConfigProvider = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(VideoConfigContext.Provider, { value: props }, children));
};
export var useVideoConfig = function () { return useContext(VideoConfigContext); };
//# sourceMappingURL=video-config-provider.js.map